import { FC, useMemo } from 'react';
import { isEmpty } from '~/modules';
import If from '../If';
import { CustomLabel, Error, Select, Wrapper } from './styles';

type Props = {
  id: string;
  name: string;
  placeholder?: string;
  options: SelectProps[];
  value: SelectProps[];
  label?: string;
  secondary?: boolean;
  error?: string | boolean;
  className?: string;
  onChange(props: ChangeMultiSelectValue): void;
  styles?: ExternalSelectProps;
};

const MultipleSelectContainer: FC<Props> = ({
  id,
  name,
  options,
  placeholder,
  value,
  label = '',
  secondary = false,
  error,
  className,
  onChange,
  styles,
}) => {
  const handleChangeOption = (option) => {
    onChange({ name, value: option });
  };

  const customStyles = useMemo(
    () => ({
      option: styles?.option,
      control: styles?.control,
      menuList: styles?.menuList,
      dropdownIndicator: styles?.dropdownIndicator,
      singleValue: styles?.singleValue,
      input: styles?.input,
      placeholder: styles?.placeholder,
      menu: styles?.menu,
    }),
    [styles],
  );

  return (
    <Wrapper className={className}>
      <If condition={!isEmpty(label)}>
        <CustomLabel>{label}</CustomLabel>
      </If>
      <Select
        isMulti
        menuPlacement="auto"
        value={value || []}
        id={id}
        secondary={secondary}
        name={name}
        placeholder={placeholder}
        options={options}
        customStyles={customStyles}
        onChange={handleChangeOption}
      />
      {error && <Error>{error}</Error>}
    </Wrapper>
  );
};
export default MultipleSelectContainer;
